import { formatLengthWithBasis } from '~/utils';
import type { SellerPriceNegotiationsQuery } from '~/graphql/graphql';

export type PriceNegotiationRow =
  SellerPriceNegotiationsQuery['sellerPriceNegotiations']['content'][number];

export type PriceNegotiationProductDisplay = {
  name: string | null;
  lengthLabel: string | null;
  code: string | null;
};

export function priceNegotiationProduct(
  negotiation: PriceNegotiationRow
): PriceNegotiationProductDisplay {
  const tally = negotiation.platformProductCannedTally;
  if (tally) {
    return {
      name: tally.name ?? null,
      lengthLabel: null,
      code: tally.platformProduct?.code ?? null,
    };
  }

  const length = negotiation.platformProductLength;
  return {
    name: length?.platformProduct?.name ?? null,
    lengthLabel: length?.lengthDisplayValue
      ? formatLengthWithBasis(length.lengthDisplayValue, length.isNominal)
      : null,
    code: length?.platformProduct?.code ?? null,
  };
}
